import {
  PAYMENT_INFORMATION_LIST_FAIL,
  PAYMENT_INFORMATION_LIST_REQUEST,
  PAYMENT_INFORMATION_LIST_SUCCESS,
} from '../constants/paymentInformationConstants';

export const paymentInformationListReducer = (state = { data: [], meta: {} }, action) => {
  switch (action.type) {
    case PAYMENT_INFORMATION_LIST_REQUEST:
      return { loading: true, data: [], meta: {} };
    case PAYMENT_INFORMATION_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload?.data || [],
        meta: action.payload?.meta || {},
      };
    case PAYMENT_INFORMATION_LIST_FAIL:
      return { loading: false, error: action.payload, data: [], meta: {} };
    default:
      return state;
  }
};
